import { render } from "./karussellSwiper.vue?vue&type=template&id=22eca280"
import script from "./karussellSwiper.vue?vue&type=script&lang=js"
export * from "./karussellSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__